<script setup lang="ts">
import { orgManageApi } from '@/api';

defineOptions({
  inheritAttrs: true,
});

const props = defineProps<{
  modelValue: { province: string; provinceId: string };
}>();
const emit = defineEmits(['update:modelValue']);

const list = ref<{ province: string; provinceId: string }[]>([]);
const fullList = computed(() => {
  if (props.modelValue?.province) {
    const hasOrg = list.value.find(item => item.province === props.modelValue.province);
    if (hasOrg) {
      return list.value;
    } else {
      return [props.modelValue, ...list.value];
    }
  }
  return list.value;
});
const remoteMethod = () => {
  orgManageApi.getCityList().then(res => {
    list.value = res || [];
  });
};
</script>
<template>
  <el-select
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    placeholder="请选择省份"
    filterable
    remote
    :remote-method="remoteMethod"
    value-key="provinceId"
  >
    <el-option v-for="item in fullList" :key="item.provinceId" :label="item.province" :value="item" />
  </el-select>
</template>
